import * as React from "react";

/** Whether a media query matches, kept current. False before the first paint
 *  and wherever `matchMedia` is missing (tests). */
export function useMedia(query: string): boolean {
  const get = () => (typeof window !== "undefined" ? window.matchMedia?.(query).matches === true : false);
  const [matches, setMatches] = React.useState(get);
  React.useEffect(() => {
    const mq = window.matchMedia?.(query);
    if (!mq) return;
    const on = () => setMatches(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [query]);
  return matches;
}

/** Below Tailwind's `md` — the phone layout. Same breakpoint as every
 *  `max-md:` class, so a component and its CSS always agree. */
export function useIsPhone(): boolean {
  return useMedia("(max-width: 767px)");
}
